"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataExtractor = void 0;
var core_shared_1 = require("@ikegps/core-shared");
var core_shared_2 = require("@ikegps/core-shared");
var index_1 = require("../../i18n/index");
var services_1 = require("../../services");
var LOCATION_PRECISION = 5;
/**
 * The DataExtractor class provides static methods for extracting printable values from CollectionModelField objects.
 */
var DataExtractor = /** @class */ (function () {
    function DataExtractor() {
    }
    /**
     * Creates a printable report item from a CollectionModelField.
     * @param field - The CollectionModelField object.
     * @returns The PrintableReportItem object.
     */
    DataExtractor.createPrintableValue = function (field) {
        var printable = { title: field.schema.displayName, value: null };
        if (field.hasValue()) {
            printable.value = this.extract(field);
        }
        return printable;
    };
    DataExtractor.extract = function (field) {
        switch (true) {
            case field instanceof core_shared_1.CollectionModelFieldSubForm:
            case field instanceof core_shared_1.CollectionModelFieldImage:
            case field instanceof core_shared_1.CollectionModelFieldTrueSize:
                return null;
            case field instanceof core_shared_1.CollectionModelFieldLocation:
                return this.extractLocation(field);
            case field instanceof core_shared_1.CollectionModelFieldVector:
                return this.extractVector(field);
            case field instanceof core_shared_1.CollectionModelFieldAnchor:
                return this.extractAnchor(field);
            case field instanceof core_shared_1.CollectionModelFieldHeight:
                return this.extractHeight(field);
            case field instanceof core_shared_1.CollectionModelFieldNumber:
                return this.extractNumber(field);
            case field instanceof core_shared_1.CollectionModelFieldYesNo:
                return this.extractYesNo(field);
            case field instanceof core_shared_1.CollectionModelFieldSelectList:
                return this.extractSelectList(field);
            case field instanceof core_shared_1.CollectionModelFieldVerticalSeparation:
                return this.extractVerticalSeparation(field);
            default:
                return this.extractString(field);
        }
    };
    DataExtractor.extractLocation = function (field) {
        var lat = core_shared_2.IkeUnit.round(field.value.latitude, LOCATION_PRECISION);
        var lng = core_shared_2.IkeUnit.round(field.value.longitude, LOCATION_PRECISION);
        if (field.value.altitude != null) {
            var alt = core_shared_2.IkeUnit.display(field.value.altitude, services_1.Services.UserSettings.units);
            return (0, index_1.Translate)(index_1.T.REPORT_COLLECTION_LAT_LNG_ALT, { lat: lat, lng: lng, alt: alt });
        }
        else {
            return (0, index_1.Translate)(index_1.T.REPORT_COLLECTION_LAT_LNG, { lat: lat, lng: lng });
        }
    };
    DataExtractor.extractVector = function (field) {
        var distance = core_shared_2.IkeUnit.display(field.value.distance, services_1.Services.UserSettings.units);
        var bearing = core_shared_2.IkeUnit.displayAngle(field.value.bearing, core_shared_2.IkeUnit.DEGREE);
        return (0, index_1.Translate)(index_1.T.REPORT_COLLECTION_VECTOR, { distance: distance, bearing: bearing });
    };
    DataExtractor.extractAnchor = function (field) {
        if (core_shared_1.CollectionModelFieldAnchor.isCollectionWithVectorTool(field.value)) {
            var distance = core_shared_2.IkeUnit.display(field.value.distance, services_1.Services.UserSettings.units);
            var bearing = core_shared_2.IkeUnit.displayAngle(field.value.bearing, core_shared_2.IkeUnit.DEGREE);
            return (0, index_1.Translate)(index_1.T.REPORT_COLLECTION_VECTOR, { distance: distance, bearing: bearing });
        }
        if (core_shared_1.CollectionModelFieldAnchor.isCollectionWithLocationTool(field.value)) {
            var lat = core_shared_2.IkeUnit.round(field.value.latitude, LOCATION_PRECISION);
            var lng = core_shared_2.IkeUnit.round(field.value.longitude, LOCATION_PRECISION);
            if (field.value.altitude != null) {
                var alt = core_shared_2.IkeUnit.display(field.value.altitude, services_1.Services.UserSettings.units);
                return (0, index_1.Translate)(index_1.T.REPORT_COLLECTION_LAT_LNG_ALT, { lat: lat, lng: lng, alt: alt });
            }
            else {
                return (0, index_1.Translate)(index_1.T.REPORT_COLLECTION_LAT_LNG, { lat: lat, lng: lng });
            }
        }
        throw new Error('Unknown anchor tool');
    };
    DataExtractor.extractHeight = function (field) {
        return core_shared_2.IkeUnit.display(field.value, services_1.Services.UserSettings.units);
    };
    DataExtractor.extractNumber = function (field) {
        if (field.isSag()) {
            return core_shared_2.IkeUnit.display(field.value, services_1.Services.UserSettings.units);
        }
        if (field.isBearing() || field.isBackBearing()) {
            return core_shared_2.IkeUnit.displayAngle(field.value, core_shared_2.IkeUnit.DEGREE);
        }
        return field.displayValue;
    };
    DataExtractor.extractYesNo = function (field) {
        return (0, index_1.Translate)(field.value ? index_1.T.YES : index_1.T.NO);
    };
    DataExtractor.extractSelectList = function (field) {
        return field.displayValue;
    };
    DataExtractor.extractVerticalSeparation = function (field) {
        return core_shared_2.IkeUnit.display(field.value, core_shared_2.IkeUnit.INCH, null, null, 0);
    };
    DataExtractor.extractString = function (field) {
        return field.displayValue;
    };
    return DataExtractor;
}());
exports.DataExtractor = DataExtractor;
//# sourceMappingURL=DataExtractor.js.map